import React, { Component } from 'react'
import styled from 'styled-components'
import CommentForm from './CommentForm'
import ReplyList from './ReplyList'
import { CommentsApi } from '../../API/api'
import replyIcon from '../../static/images/icons/reply.png'
import likeIcon from '../../static/images/icons/like.png'
import dislikeIcon from '../../static/images/icons/dislike.png'
// import { GA_Event } from '../Analytics/Analytics';
// import { media } from '../../styles/vars'

const Container = styled.li`
color: #3c444d;
font-size: 19px;
padding:20px 10px 20px;
background-color: #fff;
margin-bottom: 20px;
overflow-wrap: break-word;
&:last-child{
    /* margin-bottom:70px; */
}
@media screen and (min-width: 750px) {
    font-size:20px;
    padding: 20px;
}
`
const InfoBlock = styled.div`
margin-bottom:15px;

&.title-block{
    font-weight:700;
    font-size:22px;
    padding-right: 20px;
}
&.meta-block{
    font-size:17px;
    padding-right: 20px;
    
    > label{
        margin-left:10px;
    }
}
`
const IndexLabel = styled.label`
color:#000;
margin-left:5px;
`
const Title = styled.h4`
display:inline;
`
const Content = styled.p`
font-weight: normal;
line-height: 25px;
padding-right: 20px;
`
const ActionsContainer = styled.div`
margin-top:20px;
display:flex;
justify-content:space-between;
user-select:none;
`
const ReplyActionContainer = styled.div`
transition:filter .2s;
cursor:pointer;
${props => props.formActive ? 'filter:grayscale(100%);' : ''};
label {
    color:#33354a;
    margin-right:10px;
    font-size:90%;
    cursor:pointer;
}
> * {
    display:inline-block;
    vertical-align:middle;
    margin-right: 23px;
}img{
    transform: rotateX(180deg);
}
`
const LikeActionContainer = styled.div`
transition: opacity 1s;
${props => props.reacted ? `
opacity:.3;
> *{
    cursor:default;
}
` : ''}

label{
    margin: 0 5px;
    cursor:pointer;
}
div:first-child{
    border-left:1px solid #7e7e7e;
}
`

const ActionButton = styled.div`
display:inline-block;
veritcal-align:middle;
padding:0 10px;
transition:filter .6s;
font-weight:100;
filter:brightness(0);
cursor:pointer;
&:hover{
    filter:unset;
}
${props => props.active ?
        `
        filter:unset;
    &:hover{
        filter:unset;
    }
    ` : ''}
${
    props => props.reacted && !props.active ?
        `
    &:hover{
        filter:brightness(0);
    }
    ` : ''
    }
`

const CommentFormContainer = styled.div`
margin-top:20px;
`
class CommentItem extends Component {
    constructor(props) {
        super();
        this.toggleForm = this.toggleForm.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.addLike = this.addLike.bind(this);
        this.addDislike = this.addDislike.bind(this);
        this.state = {
            isFormActive: false,
            formState: { msg: 'חובה להזין שם', valid: false },
            reacted: false,
            liked: false,
            disliked: false,
            likeCount: props.likes,
            dislikeCount: props.dislikes,
            inputName: '',
            inputTitle: '',
            inputContent: ''
        }
    }
    toggleForm() {
        this.setState({
            isFormActive: !this.state.isFormActive
        });
    }
    handleInputChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
        window.setTimeout(() => {
            this.setState({
                formState: this.validateForm()
            });
        }, 0);
    }
    handleSubmit(event) {
        event.preventDefault();
        if (!this.state.formState.valid) {
            alert(this.state.formState.msg);
            return;
        }
        this._submitForm();
        this.setState({
            inputName: '',
            inputTitle: '',
            inputContent: '',
            isFormActive: false,
            formState: { msg: 'חובה להזין שם', valid: false }
        });
    }
    _submitForm() {
        CommentsApi.add(
            this.state.inputName,
            this.state.inputTitle,
            this.state.inputContent,
            this.props.articleRef,
            this.props.id
        );
        // GA_Event("Add_Comment", window.location.href);
        alert('תודה, קיבלנו את תגובתך ונשתדל לפרסמה בכפוף לשיקולי המערכת.');
    }
    validateForm() {
        let result = {
            msg: '',
            valid: true
        };
        const _name = this.state.inputName;
        const _title = this.state.inputTitle;
        if (_name.length < 1) {
            result.msg = 'חובה להזין שם';
            result.valid = false;
            return result;
        }
        if (_title.length < 1) {
            result.msg = 'חובה להזין כותרת';
            result.valid = false;
            return result;
        }
        return result;
    }
    addLike() {
        if (this.state.reacted) return;
        CommentsApi.like(this.props.id);
        this.setState({
            reacted: true,
            liked: true,
            likeCount: this.state.likeCount + 1
        });
    }
    addDislike() {
        if (this.state.reacted) return;
        CommentsApi.dislike(this.props.id);
        this.setState({
            reacted: true,
            disliked: true,
            dislikeCount: this.state.dislikeCount + 1
        });
    }
    render() {
        return (
            <Container className="comment-cotainer">
                <div>
                    <InfoBlock className="title-block">
                        <IndexLabel>{this.props.idx}.</IndexLabel>
                        <Title>{this.props.title}</Title>
                    </InfoBlock>
                    <InfoBlock className="meta-block">
                        <label>{this.props.author}</label>
                        <label>{this.props.publishDate}</label>
                    </InfoBlock>
                    <InfoBlock>
                        <Content>{this.props.content}</Content>
                    </InfoBlock>
                </div>
                <ActionsContainer>
                    <ReplyActionContainer formActive={this.state.isFormActive} onClick={this.toggleForm}>
                        <img src={replyIcon} alt="" />
                        <label>הגיבו לתגובה</label>
                    </ReplyActionContainer>
                    <LikeActionContainer reacted={this.state.reacted}>
                        <ActionButton
                            active={this.state.liked}
                            onClick={this.addLike}
                            reacted={this.state.reacted}
                        >
                            <label>{this.state.likeCount}</label>
                            <img src={likeIcon} alt="" />
                        </ActionButton>
                        <ActionButton
                            active={this.state.disliked}
                            onClick={this.addDislike}
                            reacted={this.state.reacted}
                        >
                            <img src={dislikeIcon} alt="" />
                            <label>{this.state.dislikeCount}</label>
                        </ActionButton>
                    </LikeActionContainer>
                </ActionsContainer>
                <CommentFormContainer>
                    <CommentForm
                        isActive={this.state.isFormActive}
                        isValid={this.state.formState.valid}
                        handleChange={this.handleInputChange}
                        inputName={this.state.inputName}
                        inputTitle={this.state.inputTitle}
                        inputContent={this.state.inputContent}
                        handleSubmit={this.handleSubmit}
                    />
                </CommentFormContainer>
                <div>
                    <ReplyList replies={this.props.replies} />
                </div>
            </Container>
        )
    }
}

export default CommentItem;
export {
    Container,
    Title,
    Content
};


// WEBPACK FOOTER //
// ./src/Components/comments/CommentItem.jsx